import { useHistory } from 'react-router-dom';

import { Button, InfoBanner, Typography } from '@cobliteam/ui/components';
import { LinearProgress } from './styles';

import { Location, OnboardingStatus } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';

import useOnboardingStore from '../../../store/useOnboardingStore';

const ProgressBar = () => {
  const history = useHistory();
  const progressBar = useOnboardingStore((state) => state.progressBar);
  const progressBarTitle = useOnboardingStore((state) => state.progressBarTitle);
  const stepsTotal = useOnboardingStore((state) => state.progressBarTourStepsTotal);
  const stepsIndex = useOnboardingStore((state) => state.tourStepsIndex);
  const setTourReset = useOnboardingStore((state) => state.setTourReset);
  const onboardingStepName = useOnboardingStore((state) => state.onboardingStepName);
  const onboardingStatus = useOnboardingStore((state) => state.onboardingStatus);
  const hasOnboarding = useOnboardingStore((state) => state.hasOnboarding);

  const handleSkip = () => {
    setTourReset();
    Analytics.track('Onboarding Dismissed', {
      context: `${onboardingStepName} step ${stepsIndex}`,
    });
  };

  const handleBack = () => history.push(Location.ONBOARDING_SETUP);

  const percentage = (stepsIndex / stepsTotal) * 100;

  if (!hasOnboarding) return null;

  if (!progressBar) return null;

  if (onboardingStatus === OnboardingStatus.COMPLETED) return null;

  return (
    <div className='absolute top-0 left-0 z-modal w-full'>
      <InfoBanner className='rounded-none bg-primary-8'>
        <InfoBanner.Content className='flex w-full flex-row justify-between'>
          <InfoBanner.Text>
            <Typography variant='description-title' color='white'>
              {progressBarTitle && <strong>Tarefa atual: </strong>}
              {progressBarTitle}
            </Typography>
          </InfoBanner.Text>

          <InfoBanner.Actions>
            <Button variant='text' className='text-white' size='sm' onClick={handleSkip}>
              Ignorar
            </Button>

            <Button variant='contained' className='bg-white text-primary hover:bg-transparent hover:text-white' size='sm' onClick={handleBack}>
              Voltar ao guia
            </Button>
          </InfoBanner.Actions>
        </InfoBanner.Content>
      </InfoBanner>
      <LinearProgress variant='determinate' value={percentage} color='primary' />
    </div>
  );
};

export default ProgressBar;
